import React from 'react';
import Footer from '../../../../studentTransfer/components/Footer';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import { useGetRectifyRefundPaymentModeContext } from './context';

const ProceedNextFooter = ({next}) => {

    const { totalCollectedAmount, amountToBePaid } = useGetRectifyRefundPaymentModeContext();

    return (
        <Footer>
            <div>Add Rectification Details</div>
            <AButton
                disabled={totalCollectedAmount < amountToBePaid}
                onClick={() => next()}
                className="button_remove_left_margin"
                variant="primary_filled"
            >
                Proceed next
            </AButton>
        </Footer>
    );
}

export default ProceedNextFooter;